import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import { DEPARTURE_DAY_SEARCH_PARAMS_KEY, TripDepartureAtFilter } from './TripDepartureAtFilter';
import { STATE_SEARCH_PARAMS_KEY, TripStateFilter } from './TripStateFilter';
import { t } from '../../services/translation/translation';

export const TripsFilters = () => {
  const [_, setSearchParams] = useSearchParams();

  const handleChange = useCallback(
    (key: string, value: string | undefined) => {
      if (value != null) {
        setSearchParams(params => {
          params.set(key, value);
          params.delete('page');
          return params;
        });
      } else {
        setSearchParams(params => {
          params.delete(key);
          params.delete('page');
          return params;
        });
      }
    },
    [setSearchParams],
  );

  const handleReset = () => {
    setSearchParams(params => {
      params.delete(STATE_SEARCH_PARAMS_KEY);
      params.delete(DEPARTURE_DAY_SEARCH_PARAMS_KEY);
      params.delete('page');
      return params;
    });
  };

  return (
    <div className="flex items-center gap-2 mb-2">
      <p className="text-sm font-normal text-gray-500 dark:text-gray-400">{t('common.filters')}</p>

      <TripDepartureAtFilter onChange={handleChange} />
      <TripStateFilter onChange={handleChange} />

      <button
        type="button"
        className="font-medium text-blue-600 dark:text-blue-500 hover:underline text-sm"
        onClick={handleReset}
      >
        {t('common.reset')}
      </button>
    </div>
  );
};
